"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "section is-fullheight has-background-light",
    staticStyle: {
      "background-image": "url('/path/to/your/background.jpg')",
      "background-size": "cover",
      "background-position": "center"
    }
  }, [_c("div", {
    staticClass: "container is-flex is-justify-content-center is-align-items-center",
    staticStyle: {
      "min-height": "100vh"
    }
  }, [_c("div", {
    staticClass: "box",
    staticStyle: {
      "max-width": "800px",
      width: "100%",
      "background-color": "rgba(255, 255, 255, 0.95)"
    }
  }, [_vm._m(0), _vm._v(" "), _c("div", {
    staticClass: "content px-3"
  }, _vm._l(_vm.secoes, function (secao, index) {
    return _c("section", {
      key: index,
      staticClass: "mb-5"
    }, [_c("h2", {
      staticClass: "title is-5 has-text-primary"
    }, [_vm._v("\n            " + _vm._s(secao.titulo) + "\n          ")]), _vm._v(" "), _c("div", {
      domProps: {
        innerHTML: _vm._s(secao.conteudo)
      }
    })]);
  }), 0)])])]);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "has-text-centered mb-6"
  }, [_c("img", {
    staticStyle: {
      width: "120px"
    },
    attrs: {
      src: require("@/assets/logo.png"),
      alt: "Logo Fiboo"
    }
  }), _vm._v(" "), _c("h1", {
    staticClass: "title is-4 has-text-info"
  }, [_vm._v("\n          Política de Privacidade\n        ")]), _vm._v(" "), _c("p", {
    staticClass: "subtitle is-6"
  }, [_vm._v("\n          Versão 02 | Atualizada em 04 de maio de 2022\n        ")])]);
}];
render._withStripped = true;